/* tslint:disable:typedef no-shadowed-variable object-literal-shorthand prefer-const */
import {Injectable} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgAppControllerConfig} from '../misc/classes/ExgAppControllerConfig';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ArrayDataSource} from '@angular/cdk/collections';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ITaskSummaryData} from '../misc/interfaces/ITaskSummaryData';
import {ICaseSummaryData} from '../misc/interfaces/ICaseSummaryData';
import {ILeistungserfassungSummaryData} from '../misc/interfaces/ILeistungserfassungSummaryData';
import {SettingsDataService} from './settings-data-service';

@Injectable({
  providedIn: 'root'
})
export class DataService extends ExcTranslation {

  Task = {
    List: {
      Get: (ID: string, data?: any, config?: ExgAppControllerConfig): any => {

      }
    },
    Summary: {
      Get: (ID?: string, data?: any, config?: ExgAppControllerConfig): ITaskSummaryData => {
        let summaryData: ITaskSummaryData = {
          ID: ID,
          isLoading: true,
          isEmpty: true,
          taskDetails: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          taskList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(tasks: any[]): void {
              this.isLoading = this.isEmpty = true;
              this.data = tasks;
              this.isEmpty = (!this.data || this.data.length === 0);
              this.isLoading = false;
            }
          },
          caseDetails: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          oeList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          Schadenort: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          workList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          oeUserList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          flowTable: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          historyTable: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          attachmentJagTable: {
            data: new ArrayDataSource([] as any),
            jagdata: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.jagdata = data;
              this.data = new ArrayDataSource(data);
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            },
          },
          dialogueQuestions: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
              config?.Events?.DialogueQuestion.DataLoaded.emit({success: this.data.length > 0, data: this.data});
            }
          },
          receiptList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            searchValue: '',
            MetaInfo: {
              dataPaging: {} as IExcDataPaging,
              dataSort: {} as IExcDataSort,
              dataFilter: {} as IExcDataFilter
            } as IExcMetaInfo,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);

            }
          },
          leistungList: {
            data: [] as any[],
            isLoading: false,
            isEmpty: true,
            searchValue: '',
            MetaInfo: {
              dataPaging: {} as IExcDataPaging,
              dataSort: {} as IExcDataSort,
              dataFilter: {} as IExcDataFilter
            } as IExcMetaInfo,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          gdvReceiptList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            searchValue: '',
            MetaInfo: {
              dataPaging: {} as IExcDataPaging,
              dataSort: {} as IExcDataSort,
              dataFilter: {} as IExcDataFilter
            } as IExcMetaInfo,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);

            }
          },
          documentTemplate: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          defaultMessages: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          questionnaireConfigurations: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          questionnaireVersion: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          calculationTemplates: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          calculationVersion: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          formularTemplates: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          formularVersion: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          photoDocumentation: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          journalMail: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          LoadSummary: (data?: any) => {
            summaryData.isLoading =
              summaryData.taskDetails.isLoading =
                summaryData.caseDetails.isLoading =
                  summaryData.oeList.isLoading =
                    summaryData.Schadenort.isLoading =
                      summaryData.workList.isLoading =
                        summaryData.oeUserList.isLoading =
                          summaryData.flowTable.isLoading =
                            summaryData.historyTable.isLoading =
                              summaryData.attachmentJagTable.isLoading =
                                summaryData.dialogueQuestions.isLoading =
                                  summaryData.receiptList.isLoading =
                                    summaryData.documentTemplate.isLoading =
                                      summaryData.defaultMessages.isLoading =
                                        summaryData.questionnaireConfigurations.isLoading =
                                          summaryData.questionnaireVersion.isLoading =
                                            summaryData.calculationTemplates.isLoading =
                                              summaryData.calculationVersion.isLoading =
                                                summaryData.formularTemplates.isLoading =
                                                  summaryData.formularVersion.isLoading =
                                                    summaryData.taskList.isLoading =
                                                      summaryData.photoDocumentation.isLoading =
                                                        summaryData.journalMail.isLoading =
                                                          true;
            if (data) {
              initializeView(data);
              return;
            }
            this.excRest
              .get(this.excRest.computeUrl('TaskR_Summary', {vorgID: summaryData.ID}))
              .subscribe((response) => {
                initializeView(response);
              });
          }
        };
        const initializeView = (response: any) => {
          if (response.success && response.data) {
            summaryData.ID = response.data.Vorgang.vorgID;
            summaryData.taskDetails.loadData(response.data.Vorgang);
            summaryData.caseDetails.loadData(response.data.Auftrag);
            summaryData.oeList.loadData(response.data.OEs);
            summaryData.Schadenort.loadData(response.data.Schadenort);
            summaryData.workList.loadData(response.data.Ablaufplan);
            summaryData.defaultMessages.loadData(response.data.Standardnachricht);
            summaryData.flowTable.loadData(response.data.Flow);
            summaryData.historyTable.loadData(response.data.History);
            summaryData.attachmentJagTable.loadData(response.data.AttachmentsJag);
            summaryData.dialogueQuestions.loadData(response.data.DialogFrage);
            summaryData.receiptList.loadData(response.data.Receipts);
            summaryData.leistungList.loadData(response.data.Leistungserfassung);
            summaryData.documentTemplate.loadData(response.data.DocumentTemplate);
            summaryData.taskList.loadData(response.data.Vorgaenge);
            summaryData.questionnaireConfigurations.loadData(response.data.QuestionnaireConfigurations);
            summaryData.questionnaireVersion.loadData(response.data.QuestionnaireVersion);
            summaryData.calculationTemplates.loadData(response.data.CalculationTemplate);
            summaryData.calculationVersion.loadData(response.data.CalculationVersion);
            summaryData.formularTemplates.loadData(response.data.FormularTemplate);
            summaryData.formularVersion.loadData(response.data.FormularVersion);
            summaryData.photoDocumentation.loadData(response.data.PhotoDocumentation);
            summaryData.journalMail.loadData(response.data.JournalMail);
          } else {
            summaryData.ID = undefined;
            summaryData.taskDetails.loadData({} as any);
            summaryData.caseDetails.loadData({} as any);
            summaryData.oeList.loadData([] as any[]);
            summaryData.Schadenort.loadData({} as any);
            summaryData.workList.loadData([] as any[]);
            summaryData.defaultMessages.loadData([] as any[]);
            summaryData.flowTable.loadData([] as any[]);
            summaryData.historyTable.loadData([] as any[]);
            summaryData.attachmentJagTable.loadData([] as any[]);
            summaryData.dialogueQuestions.loadData([] as any[]);
            summaryData.receiptList.loadData([] as any[]);
            summaryData.leistungList.loadData([] as any[]);
            summaryData.documentTemplate.loadData([] as any[]);
            summaryData.taskList.loadData([] as any[]);
            summaryData.questionnaireConfigurations.loadData([] as any[]);
            summaryData.questionnaireVersion.loadData([] as any[]);
            summaryData.calculationTemplates.loadData([] as any[]);
            summaryData.calculationVersion.loadData([] as any[]);
            summaryData.formularTemplates.loadData([] as any[]);
            summaryData.formularVersion.loadData([] as any[]);
            summaryData.photoDocumentation.loadData([] as any[]);
            summaryData.journalMail.loadData([] as any[]);
          }
          summaryData.isLoading = false;
          config?.Events?.Task?.Summary?.DataLoaded?.emit({
            success: (response.success && response.data),
            data: response
          });
        };
        if (ID || data) {
          summaryData.LoadSummary(data);
        }
        return summaryData;
      }
    }
  };

  Case = {
    List: {
      Get: (ID: string, data?: any, config?: ExgAppControllerConfig): any => {

      }
    },
    Summary: {
      Get: (ID?: string, data?: any, config?: ExgAppControllerConfig): ICaseSummaryData => {
        let summaryData: ICaseSummaryData = {
          ID: ID,
          isLoading: true,
          isEmpty: true,
          caseDetails: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          Schadenort: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          oeList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          taskList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            searchValue: '',
            MetaInfo: {
              dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
              dataSort: {} as IExcDataSort,
              dataFilter: {} as IExcDataFilter
            } as IExcMetaInfo,
            paging: {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0
            } as any,
            loadData(data: any[], paging?: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.paging = paging;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          receiptList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            searchValue: '',
            MetaInfo: {
              dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
              dataSort: {} as IExcDataSort,
              dataFilter: {} as IExcDataFilter
            } as IExcMetaInfo,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);

            }
          },
          leistungList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            searchValue: '',
            MetaInfo: {
              dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
              dataSort: {} as IExcDataSort,
              dataFilter: {} as IExcDataFilter
            } as IExcMetaInfo,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);

            }
          },
          gdvReceiptList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          workList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          oeUserList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          flowTable: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          historyTable: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          attachmentJagTable: {
            data: new ArrayDataSource([] as any),
            jagdata: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.jagdata = data;
              this.data = new ArrayDataSource(data);
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            },
          },
          documentTemplate: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          defaultMessages: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          wert1914Faktor: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          questionnaireConfigurations: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          questionnaireVersion: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          calculationTemplates: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          calculationVersion: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          formularTemplates: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          formularVersion: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          photoDocumentation: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || data.length === 0);
            }
          },
          LoadSummary: (data?: any) => {
            summaryData.isLoading =
              summaryData.taskList.isLoading =
                summaryData.caseDetails.isLoading =
                  summaryData.oeList.isLoading =
                    summaryData.Schadenort.isLoading =
                      summaryData.workList.isLoading =
                        summaryData.oeUserList.isLoading =
                          summaryData.flowTable.isLoading =
                            summaryData.historyTable.isLoading =
                              summaryData.attachmentJagTable.isLoading =
                                summaryData.receiptList.isLoading =
                                  summaryData.gdvReceiptList.isLoading =
                                    summaryData.documentTemplate.isLoading =
                                      summaryData.defaultMessages.isLoading =
                                        summaryData.wert1914Faktor.isLoading =
                                          summaryData.questionnaireConfigurations.isLoading =
                                            summaryData.questionnaireVersion.isLoading =
                                              summaryData.calculationTemplates.isLoading =
                                                summaryData.calculationVersion.isLoading =
                                                  summaryData.formularTemplates.isLoading =
                                                    summaryData.formularVersion.isLoading =
                                                      summaryData.photoDocumentation.isLoading =
                                                        true;
            if (data) {
              initializeView(data);
              return;
            }
            this.excRest
              .get(this.excRest.computeUrl('CaseR_Summary', {auID: summaryData.ID}))
              .subscribe((response) => {
                initializeView(response);
              });
          }
        };
        const initializeView = (response: any) => {
          if (response.success && response.data) {
            summaryData.ID = response.data.Auftrag.auID;
            summaryData.taskList.loadData(response.data.Vorgaenge, response.paging.Vorgaenge);
            summaryData.caseDetails.loadData(response.data.Auftrag);
            summaryData.oeList.loadData(response.data.OEs);
            summaryData.Schadenort.loadData(response.data.Schadenort);
            summaryData.workList.loadData(response.data.Ablaufplan);
            summaryData.defaultMessages.loadData(response.data.Standardnachricht);
            summaryData.flowTable.loadData(response.data.Flow);
            summaryData.historyTable.loadData(response.data.History);
            summaryData.attachmentJagTable.loadData(response.data.AttachmentsJag);
            summaryData.receiptList.loadData(response.data.Receipts);
            summaryData.leistungList.loadData(response.data.Leistungserfassung);
            summaryData.gdvReceiptList.loadData(response.data.GdvReceiptList);
            summaryData.documentTemplate.loadData(response.data.DocumentTemplate);
            summaryData.wert1914Faktor.loadData(response.data.Wert1914Faktor.setWert1914Faktor);
            summaryData.questionnaireConfigurations.loadData(response.data.QuestionnaireConfigurations);
            summaryData.questionnaireVersion.loadData(response.data.QuestionnaireVersion);
            summaryData.calculationTemplates.loadData(response.data.CalculationTemplate);
            summaryData.calculationVersion.loadData(response.data.CalculationVersion);
            summaryData.formularTemplates.loadData(response.data.FormularTemplate);
            summaryData.formularVersion.loadData(response.data.FormularVersion);
            summaryData.photoDocumentation.loadData(response.data.PhotoDocumentation);
          } else {
            summaryData.ID = undefined;
            summaryData.taskList.loadData([] as any[], {} as any);
            summaryData.caseDetails.loadData({} as any);
            summaryData.oeList.loadData([] as any[]);
            summaryData.Schadenort.loadData({} as any);
            summaryData.workList.loadData([] as any[]);
            summaryData.defaultMessages.loadData([] as any[]);
            summaryData.flowTable.loadData([] as any[]);
            summaryData.historyTable.loadData([] as any[]);
            summaryData.attachmentJagTable.loadData([] as any[]);
            summaryData.receiptList.loadData([] as any[]);
            summaryData.leistungList.loadData([] as any[]);
            summaryData.gdvReceiptList.loadData([] as any[]);
            summaryData.documentTemplate.loadData([] as any[]);
            summaryData.wert1914Faktor.loadData({} as any);
            summaryData.questionnaireConfigurations.loadData([] as any[]);
            summaryData.questionnaireVersion.loadData([] as any[]);
            summaryData.calculationTemplates.loadData([] as any[]);
            summaryData.calculationVersion.loadData([] as any[]);
            summaryData.formularTemplates.loadData([] as any[]);
            summaryData.formularVersion.loadData([] as any[]);
            summaryData.photoDocumentation.loadData([] as any[]);
          }
          summaryData.isLoading = false;
          config?.Events?.Case?.Summary?.DataLoaded?.emit({
            success: (response.success && response.data),
            data: response
          });
        };
        if (ID || data) {
          summaryData.LoadSummary(data);
        }
        return summaryData;
      }
    }
  };

  Leistungserfassung = {
    Summary: {
      Get: (ID?: string, data?: any, config?: ExgAppControllerConfig): ILeistungserfassungSummaryData => {
        let summaryData: ILeistungserfassungSummaryData = {
          ID: ID,
          isLoading: true,
          isEmpty: true,
          serviceRecordDetails: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          foreignData: {
            data: {} as any,
            isLoading: true,
            isEmpty: true,
            loadData(data: any) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || Object.keys(this.data).length === 0);
            }
          },
          historyTable: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          positionList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          priceList: {
            data: [] as any[],
            isLoading: true,
            isEmpty: true,
            loadData(data: any[]) {
              this.isLoading = this.isEmpty = true;
              this.data = data;
              this.isLoading = false;
              this.isEmpty = (!this.data || this.data.length === 0);
            }
          },
          LoadSummary: (data?: any): void => {
            summaryData.isLoading =
              summaryData.serviceRecordDetails.isLoading =
                summaryData.foreignData.isLoading =
                  summaryData.historyTable.isLoading =
                    summaryData.positionList.isLoading =
                      summaryData.priceList.isLoading =
                        true;
            if (data) {
              initializeView(data);
              return;
            }
            this.excRest
              .get(this.excRest.computeUrl('LeistungserfassungSummary', {leID: summaryData.ID}))
              .subscribe((response) => {
                initializeView(response);
              });
          }
        };
        const initializeView = (response: any) => {
          if (response.success && response.data) {
            summaryData.serviceRecordDetails.loadData(response.data.HeaderData);
            summaryData.foreignData.loadData(response.data.ForeignData);
            summaryData.historyTable.loadData(this.historyRows(response.data.HistoryData));
            summaryData.positionList.loadData(response.data.Leistungen);
            summaryData.priceList.loadData(response.data.Preisliste);
          } else {
            summaryData.serviceRecordDetails.loadData({} as any);
            summaryData.foreignData.loadData({} as any);
            summaryData.historyTable.loadData([] as any[]);
            summaryData.positionList.loadData([] as any[]);
            summaryData.priceList.loadData([] as any[]);
          }
          summaryData.isLoading = false;
          summaryData.isEmpty = summaryData.serviceRecordDetails.isEmpty;
          config?.Events?.Leistungserfassung?.Summary?.DataLoaded?.emit({
            success: (response.success && response.data),
            data: response
          });
        };
        if (ID || data) {
          summaryData.LoadSummary(data);
        }
        return summaryData;
      }
    }
  };

  historyRows(entries: any[]): any[] {
    return (entries || []).map((entry: any) => ({
      lnkID: entry.ID,
      lnkCRD: entry.TS,
      lnkCRU: entry.Originator,
      lnkName: this.historyText(entry)
    }));
  }

  historyText(entry: any): string {
    const block = 'LeistungserfassungCheckviewComponent.';
    if (entry.Type === 'StatusChanged') {
      return this.getTranslation(block + 'HistoryType.StatusChanged', {
        ValueOld: this.getTranslation(block + 'ServiceRecordStatus.' + entry.ValueOld),
        ValueNew: this.getTranslation(block + 'ServiceRecordStatus.' + entry.ValueNew)
      });
    }
    if (entry.Type === 'Picked') {
      return this.getTranslation(block + 'HistoryType.Picked.' + (entry.ValueNew ? 'occupied' : 'available'));
    }
    if (entry.Type === 'Action') {
      return entry.Message;
    }
    return this.getTranslation(block + 'HistoryType.' + entry.Type);
  }

  constructor(private excRest: ExcRestService, public Settings: SettingsDataService) {
    super();
  }
}
